export const SITE_ID_OPTIONS = [
  { value: 1, label: 'Early Bird Books' },
  { value: 2, label: 'The Line Up' },
  { value: 3, label: 'The Portalist' },
  { value: 7, label: 'Murder & Mayhem' },
  { value: 8, label: 'A Love So True' },
  { value: 9, label: 'Explore The Archive' },
  { value: 12, label: 'Bloodhound' },
];

export const CAMPAIGN_TYPE_OPTIONS = [
  { value: 1, label: 'Downpriced Campaign' },
  { value: 2, label: 'Non Downpriced Campaign' },
  { value: 3, label: 'Library Campaign' },
];

export const PRODUCT_TYPE_OPTIONS = [
  { value: 'ebook', label: 'Ebook' },
  { value: 'audio', label: 'Audio' },
  { value: 'print', label: 'Print' },
];

export const OPTIONAL_ED_OPTIONS = [
  { value: 1, label: 'Yes' },
  { value: 2, label: 'No' },
];

export const RULE_SET_TYPE_OPTIONS = [
  { value: 'award', label: 'Award' },
  { value: 'customcategory', label: 'Custom Category' },
  { value: 'author', label: 'Author' },
  { value: 'daydependent', label: 'Day Dependent' },
  { value: 'campaignstartdate', label: 'Campaign Start Date' },
  { value: 'notes', label: 'Notes' },
  { value: 'dependentCampaignCreation', label: 'Dependent Campaign Creation' },
];

export const AUDIO_CONTRACT_STATUS_OPTIONS = [
  { value: 'Valid', label: 'Valid' },
  { value: 'In-Renewal', label: 'In-Renewal' },
  { value: 'Expired', label: 'Expired' },
];

export const BOOK_TYPE_OPTIONS = [
  { value: 'All', label: 'All' },
  { value: 'Single', label: 'Single' },
  { value: 'Bundle', label: 'Bundle' },
];

export const ROLE_OPTIONS = [
  { value: 'super admin', label: 'Super Admin' },
  { value: 'administrator', label: 'Administrator' },
  { value: 'editor', label: 'Editor' },
  { value: 'contributor', label: 'Contributor' },
  { value: 'subscriber', label: 'Subscriber' },
];

export const EVENT_TYPE_OPTIONS = [
  { value: 'Birthday', label: 'Birthday' },
  { value: 'Anniversary', label: 'Anniversary' },
  { value: 'Death Anniversary', label: 'Death Anniversary' },
  { value: 'TV Shows', label: 'TV Shows' },
  { value: 'Movie Opening', label: 'Movie Opening' },
  { value: 'Holiday', label: 'Holiday' },
  { value: 'Frontlist Launch', label: 'Frontlist Launch' },
  { value: 'External Frontlist Launch', label: 'External Frontlist Launch' },
  { value: 'Monthly Observance', label: 'Monthly Observance' },
  { value: 'Other', label: 'Other' },
];

export const PRIORITY_OPTIONS = [
  { value: 'TITLE', label: 'Title' },
  { value: 'AUTHOR', label: 'Author' },
  { value: 'PUBLISHER', label: 'Publisher' },
];

export const TAG_GENERATOR_SEARCH_OPTIONS = [
  { value: 'ALL', label: 'Everything' },
  { value: 'IMAGE_TAGS', label: 'Image Tags' },
  { value: 'CHAT_GPT', label: 'ChatGPT Tags' },
];

export const PRICE_CHANGE_TYPE_OPTIONS = [
  { value: 'downprice', label: 'Down Price' },
  { value: 'dlp', label: 'DLP Change' },
  { value: 'manual', label: 'Manual Change' },
  { value: 'system', label: 'System Update' },
];

export const DESTINATION_TYPE_OPTIONS = [
  { value: 'campaign', label: 'Campaign Update' },
  { value: 'dlp', label: 'DLP Update' },
];

export const PRICELOG_UPDATE_LOG_OPTIONS = [
  { value: 'title', label: 'Title Wise' },
  { value: 'batch', label: 'Batch Wise' },
];

export const CAMPAIGN_NAME_FOR_SERVICE_REQUEST = [
  { label: 'Weekly', value: 'Weekly' },
  { label: 'Content NL Spotlight', value: 'Content NL Spotlight' },
];

export const DAY_OPTIONS = [
  { label: 'Monday', value: 1 },
  { label: 'Tuesday', value: 2 },
  { label: 'Wednesday', value: 3 },
  { label: 'Thursday', value: 4 },
  { label: 'Friday', value: 5 },
  { label: 'Saturday', value: 6 },
  { label: 'Sunday', value: 7 },
];

export const NUMBER_OF_WEEK_OPTIONS = [
  { label: '1st', value: 1 },
  { label: '2nd', value: 2 },
  { label: '3rd', value: 3 },
  { label: '4th', value: 4 },
  { label: '5th', value: 5 },
];

export const FREQUENCY_TYPE_OPTIONS = [
  { label: 'Daily', value: 'Daily' },
  { label: 'Weekly', value: 'Weekly' },
  { label: 'Bi-Weekly', value: 'Bi-Weekly' },
  { label: 'Monthly', value: 'Monthly' },
];

export const POST_PROCESSING_FILTERS = [
  { label: 'Custom Categories', value: 'CUSTOM_CATEGORIES' },
  { label: 'Publishers', value: 'PUBLISHERS' },
  { label: 'Public Domain', value: 'PUBLIC_DOMAIN' },
  { label: 'Business Area', value: 'BUSINESS_AREA' },
  { label: 'Synchronizer Promo Recommendation', value: 'SYNCHRONIZER_PROMO_RECOMMENDATION' },
];

export const LENDING_DEALS_PRIORITY_TYPE_OPTIONS = [
  { value: 'P1', label: 'Priority 1' },
  { value: 'P2', label: 'Priority 2' },
  { value: 'P3', label: 'Priority 3' },
];

export const RECOMMENDATION_OPTIONS = [
  { label: 'Promote', value: 'Promote' },
  { label: "Don't promote", value: "Don't promote" },
  { label: 'Review', value: 'Review' },
];

export const PRIORITY_BUCKET_OPTIONS = [
  { label: 'P1', value: 'P1' },
  { label: 'P2', value: 'P2' },
  { label: 'P3', value: 'P3' },
];
